import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

const loadDraggable = require('bundle-loader?lazy&name=draggable!../lib/draggable.pack');
require('intersection-observer');

export default (el, props) => {
    const dom = $(el);
    const dragger = dom.find('[data-dragger]');
    const slider = dom.find('[data-slider]');
    const dragImage = dom.find('[data-image-wrap]').eq(0);
    const dragWrap = dom.find('[data-wrap]').eq(0);
    const instructions = dom.find('[data-instructions]');
    let hasDragged = false;
    let hasReleased = false;
    let pauseDrag = false;
    let snapZone;
    let viewportWidth;
    let dragInstance;

    const onDrag = () => {
        if (!pauseDrag) {
            const x = Math.round(dragInstance.x);
            TweenMax.set(dragWrap.get(0), { x });
            TweenMax.set(dragImage.get(0), { x: -x });
        }
    };

    const onDragEnd = () => {
        const currentZone = dragInstance.endX;

        if (!hasReleased) {
            hasReleased = true;
            dom.addClass('js-has-engaged');
        }

        dom.removeClass('js-is-engaging');

        if (currentZone < snapZone && currentZone > -snapZone) {
            pauseDrag = true;
            TweenMax.to(dragger.get(0), 0.5, { x: 0, ease: Back.easeOut });
            TweenMax.to(dragWrap.get(0), 0.5, { x: 0, ease: Back.easeOut });
            TweenMax.to(dragImage.get(0), 0.5, { x: 0, ease: Back.easeOut });
            dragInstance.update(true);
            setTimeout(() => {
                pauseDrag = false;
            }, 500);
        }
    };

    const onDragStart = () => {
        if (!hasDragged) {
            hasDragged = true;
            TweenMax.set(instructions.get(0), { clearProps: 'all' });
        }

        dom.addClass('js-is-engaging');
    };

    const inviewSetup = () => {
        if ($('html').hasClass('is-live-preview')) {
            return;
        }

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const { target, isIntersecting } = entry;

                if (isIntersecting && entry.intersectionRatio >= 0.6) {
                    // const moveAmount = instructions.width();
                    const moveAmount = dom.width() / 8;

                    TweenMax.to(dragger.get(0), 0.75, { x: moveAmount / 2, ease: Quad.easeInOut });
                    TweenMax.to(dragWrap.get(0), 0.75, { x: moveAmount / 2, ease: Quad.easeInOut });
                    TweenMax.to(dragImage.get(0), 0.75, { x: -moveAmount / 2, ease: Quad.easeInOut });

                    TweenMax.to(dragger.get(0), 0.65, { x: -moveAmount / 3, delay: 0.75, ease: Quad.easeInOut });
                    TweenMax.to(dragWrap.get(0), 0.65, { x: -moveAmount / 3, delay: 0.75, ease: Quad.easeInOut });
                    TweenMax.to(dragImage.get(0), 0.65, { x: moveAmount / 3, delay: 0.75, ease: Quad.easeInOut });

                    TweenMax.to(dragger.get(0), 0.75, { x: 0, delay: 1.25, ease: Back.easeOut });
                    TweenMax.to(dragWrap.get(0), 0.75, { x: 0, delay: 1.25, ease: Back.easeOut });
                    TweenMax.to(dragImage.get(0), 0.75, { x: 0, delay: 1.25, ease: Back.easeOut });

                    TweenMax.to(instructions.get(0), 0.75, { opacity: 1, delay: 0.3 });
                    observer.unobserve(target);
                }
            });
        }, {
            root: null,
            threshold: 0.6
        });
        observer.observe(el);
    };

    const initSlider = () => {
        dragInstance = Draggable.create(dragger.get(0), { type: 'x', edgeResistance: 0.75, bounds: slider.get(0), throwProps: true, onThrowUpdate: onDrag, onDrag, onDragStart, overshootTolerance: 0.01, allowNativeTouchScrolling: false, onDragEnd, zIndexBoost: false })[0];

        inviewSetup();

        Viewport.on('resize', onResize);
    };

    const onResize = () => {
        if (Viewport.width !== viewportWidth) {
            if (dragInstance.x !== 0) {
                TweenMax.to(dragger.get(0), 0.5, { x: 0 });
                TweenMax.to(dragWrap.get(0), 0.5, { x: 0 });
                TweenMax.to(dragImage.get(0), 0.5, { x: 0 });
            }
            dragInstance.applyBounds();
            viewportWidth = Viewport.width;
            snapZone = dragger.width() * 1.5;
        }
    };

    const init = () => {
        viewportWidth = Viewport.width;
        snapZone = dragger.width() * 1.5;
        loadDraggable(() => {
            initSlider();
        });
    };

    const destroy = () => {
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/LandingSlider.js